"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const store_1 = require("../../store");
const autocomplete_menu_1 = require("../autocomplete.menu/autocomplete.menu");
const mithril_component_1 = require("../mithril.component");
const input_1 = require("./input");
const input_state_1 = require("./input.state");
class TagNameInputState extends mithril_component_1.IMithrilStateComponent {
    get value() {
        return this.state.value;
    }
    constructor() {
        super();
        this.state = new input_state_1.InputState(i18n_1.T.TAG_NAME);
        this.menu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: this.state,
            options: () => this.autoCompleteOptions,
            onselect: (opt) => this.accept(opt.id),
            showNew: true,
        });
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: 'c-TagInput' }, [input_1.Input.view(this.state), this.menu.view()]);
    }
    accept(value) {
        if (value) {
            this.state.setValue(value);
        }
    }
    clearValue() {
        this.state.setValue(null);
    }
    get autoCompleteOptions() {
        const tags = [];
        for (const tag of store_1.AppStore.Tag.all) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary == null || tagSummary.revisions.length === 0) {
                continue;
            }
            tags.push({ id: tag.name, value: tag.name });
        }
        return tags;
    }
}
exports.TagNameInputState = TagNameInputState;
tslib_1.__decorate([
    mobx_1.action.bound
], TagNameInputState.prototype, "accept", null);
tslib_1.__decorate([
    mobx_1.computed
], TagNameInputState.prototype, "autoCompleteOptions", null);
//# sourceMappingURL=tag.input.state.js.map